/* Cart line item redesign — volume discount card (full cart page only).
   Wraps AIOD's existing .cs_volume_msg_wrpr message (already turned into a
   clickable "Add X more for $Y more" button by the inline unified-cart-patch
   script in sections/main-cart-items.liquid) into a bordered card with a
   progress bar and a current/next price-break preview. Does not recompute
   the quantity-break math — it only reads values the existing script
   already computed (data-add, the per-each hint text) and clones the
   existing button so its click-to-add-quantity behavior keeps working
   unchanged.

   A full all-breakpoints tier table (1-24, 25-49, ...) isn't buildable here:
   AIOD only renders that table client-side on the product page, and its
   wrapper ships empty in the server HTML (confirmed by fetching a PDP
   directly — .csapps-volume-discount-tiers has 0 rows before AIOD's own
   script runs), so a background fetch can't see it. The preview below is
   scoped to what's actually available in the cart: the current line's price
   and the next tier's price/quantity, both already computed by the base
   script for the "Add X more" message. */
(function () {
  if (window.__cliVolCardApplied) return;
  window.__cliVolCardApplied = true;

  var rootSel = '#main-cart-items';

  function toNum(s) {
    var v = parseFloat(String(s || '').replace(/[^\d.-]/g, ''));
    return isFinite(v) ? v : null;
  }
  function fmtMoney(n) {
    if (!Number.isFinite(n)) return '';
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }
  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  function renderPreview(dropdown, row, addBtn, currentQty) {
    var rows = [];

    var priceEl = row.querySelector('td.cart-item__prices .cs_final_price, td.cart-item__prices .money:not(del)');
    var currentEach = priceEl ? toNum(priceEl.textContent) : null;
    if (Number.isFinite(currentEach)) {
      rows.push({ label: currentQty + ' (current)', each: currentEach, current: true });
    }

    var addQty = parseInt(addBtn.dataset.add || '0', 10);
    var hintEl = addBtn.querySelector('.cs-next-ea-hint');
    var nextEach = hintEl ? toNum(hintEl.textContent) : null;
    if (Number.isFinite(nextEach) && addQty > 0) {
      rows.push({ label: (currentQty + addQty) + '+', each: nextEach, current: false });
    }

    if (!rows.length) {
      dropdown.innerHTML = '<div class="cs-vol-card__tier-empty">Price breaks unavailable</div>';
      return;
    }

    dropdown.innerHTML = rows
      .map(function (r) {
        return (
          '<div class="cs-vol-card__tier-row' + (r.current ? ' cs-vol-card__tier-row--current' : '') + '">' +
          '<span class="cs-vol-card__tier-qty">' + r.label + '</span>' +
          '<span class="cs-vol-card__tier-price">' + fmtMoney(r.each) + ' ea.</span>' +
          '</div>'
        );
      })
      .join('');
  }

  function buildCard(msg, row) {
    if (!msg) return;
    // cliEnhanced means we already built the card once - but AIOD can wipe
    // msg's content back to raw text later (see the matching fix on
    // processMsg's csBound in sections/main-cart-items.liquid), which also
    // removes .cs-vol-card since it's rebuilt from that button. Only skip
    // when the card is actually still present; otherwise rebuild.
    if (msg.dataset.cliEnhanced && row.querySelector('.cs-vol-card')) return;
    var addBtn = msg.querySelector('.cs-next-qty[data-add]');
    if (!addBtn) return; // wait until the base script has computed the message
    msg.dataset.cliEnhanced = '1';

    var wrap = msg.closest('.cs_volume_msg_wrpr') || msg.parentElement;
    var outer = (wrap && wrap.closest('.cs_volume_msg')) || wrap;

    // Clone the button rather than moving the original: AIOD watches its own
    // injected .cs_volume_msg subtree and re-injects a duplicate if that
    // content is reparented or removed. The clone carries the same
    // data-add/text, and the base script's delegated click handler matches
    // any .cs-next-qty element regardless of which DOM copy was clicked, so
    // "add to reach the next tier" still works from the clone. The original
    // stays exactly where AIOD put it, just hidden via CSS.
    var addBtnClone = addBtn.cloneNode(true);
    if (outer) outer.classList.add('cli-vol-msg-hidden');

    var prevCard = row.querySelector('.cs-vol-card');
    if (prevCard) prevCard.remove();

    var card = document.createElement('div');
    card.className = 'cs-vol-card';

    var dropdown = document.createElement('div');
    dropdown.className = 'cs-vol-card__dropdown';
    dropdown.hidden = true;

    // Chevron toggles the price-breaks dropdown below (was a separate "See
    // price breaks" line before, then an X - now just the caret itself).
    var dismissBtn = document.createElement('button');
    dismissBtn.type = 'button';
    dismissBtn.className = 'cs-vol-card__toggle';
    dismissBtn.setAttribute('aria-label', 'See price breaks');
    dismissBtn.setAttribute('aria-expanded', 'false');
    dismissBtn.innerHTML =
      '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
    dismissBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var opening = dropdown.hidden;
      dropdown.hidden = !opening;
      dismissBtn.setAttribute('aria-expanded', String(opening));
      dismissBtn.setAttribute('aria-label', opening ? 'Hide price breaks' : 'See price breaks');
      dismissBtn.classList.toggle('is-open', opening);
    });

    var main = document.createElement('div');
    main.className = 'cs-vol-card__main';

    var badge = document.createElement('span');
    badge.className = 'cs-vol-card__badge';
    badge.setAttribute('aria-hidden', 'true');
    badge.innerHTML =
      '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l2.4 7.2H22l-6 4.4 2.3 7.2L12 16.4 5.7 20.8 8 13.6 2 9.2h7.6L12 2z"/></svg>';

    var body = document.createElement('div');
    body.className = 'cs-vol-card__body';

    var headline = document.createElement('p');
    headline.className = 'cs-vol-card__headline';
    headline.appendChild(addBtnClone);

    body.appendChild(headline);
    main.appendChild(badge);
    main.appendChild(body);

    card.appendChild(dismissBtn);
    card.appendChild(main);
    card.appendChild(dropdown);

    var qtyInput = row.querySelector('input.quantity__input');
    var currentQty = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;

    renderPreview(dropdown, row, addBtn, currentQty);

    // Place the card before the free-items promo card if one is present in
    // this line item, so the volume-discount card reads first (matching the
    // reference layout) without touching the <td>'s table-cell display —
    // switching it to flex to use CSS `order` broke border-collapse across
    // the row (cell borders landed at different heights) since a table cell
    // can't be both a flex container and a normal table cell.
    var detailsCell = row.querySelector('td.cart-item__details');
    var promoCard = detailsCell && detailsCell.querySelector('.promo-free-items');
    if (promoCard && promoCard.parentNode === detailsCell) {
      detailsCell.insertBefore(card, promoCard);
    } else if (outer && outer.parentNode) {
      outer.parentNode.insertBefore(card, outer);
    } else if (detailsCell) {
      detailsCell.appendChild(card);
    }
  }

  function scan(root) {
    root = root || document.querySelector(rootSel);
    if (!root) return;
    root.querySelectorAll('tr.cart-item').forEach(function (row) {
      var msg = row.querySelector('.cs_vol_txt');
      // Always call buildCard when there's a button to build from - it
      // no-ops on its own if the card's already there and intact, and
      // rebuilds it if AIOD wiped it out from under an already-enhanced row.
      if (msg && msg.querySelector('.cs-next-qty[data-add]')) {
        buildCard(msg, row);
      }
    });
  }

  var debouncedScan = debounce(function () { scan(); }, 150);

  function bind() {
    var root = document.querySelector(rootSel);
    if (!root) return;
    var mo = new MutationObserver(debouncedScan);
    // characterData, not just childList: AIOD sometimes rewrites the
    // message's text in place rather than replacing nodes outright - same
    // reasoning as the characterData flag on the row-level observer in
    // sections/main-cart-items.liquid.
    mo.observe(root, { childList: true, subtree: true, characterData: true });
    scan(root);
    // Belt-and-suspenders retries, matching main-cart-items.liquid's own
    // retry schedule for the same class of missed-mutation race.
    [300, 800, 1500, 3000].forEach(function (delay) {
      setTimeout(function () { scan(document.querySelector(rootSel) || root); }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();
